import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/Auth/index";
import { AuthStoreModuleTypes } from "./modules/Auth/interface";
import { RoleStoreModuleTypes } from "./modules/Role/interface";
import { UserStoreModuleTypes } from "./modules/User/interface";
import { AgenceStoreModuleTypes } from "./modules/Agence/interface";
import { StateStoreModuleTypes } from "./modules/State/interface";
import { DeviceStoreModuleTypes } from "./modules/Device/interface";
import { CategoryStoreModuleTypes } from "./modules/Category/interface";
import { SurveyStoreModuleTypes } from "./modules/Survey/interface";
import { PosteStoreModuleTypes } from "./modules/Poste/interface";
import { LogStoreModuleTypes } from "./modules/Log/interface";
import { CameraResolutionStoreModuleTypes } from "./modules/CameraResolution/interface";
import { MainStateStoreModuleTypes } from "./modules/MainState/interface";
import { CameraImageStoreModuleType } from "./modules/CameraImage/interface";

Vue.use(Vuex);

type StoreModules = {
  authModule: AuthStoreModuleTypes;
  userModule: UserStoreModuleTypes;
  roleModule: RoleStoreModuleTypes;
  agenceModule: AgenceStoreModuleTypes;
  stateModule: StateStoreModuleTypes;
  deviceModule: DeviceStoreModuleTypes;
  categoryModule: CategoryStoreModuleTypes;
  surveyModule: SurveyStoreModuleTypes;
  posteModule: PosteStoreModuleTypes;
  logModule: LogStoreModuleTypes;
  historicModule: CategoryStoreModuleTypes;
  cameraResolutionModule: CameraResolutionStoreModuleTypes;
  mainStateModule: MainStateStoreModuleTypes;
  cameraImageModule: CameraImageStoreModuleType;
};

export type Store = AuthStoreModuleTypes<Pick<StoreModules, "authModule">> &
  UserStoreModuleTypes<Pick<StoreModules, "userModule">> &
  RoleStoreModuleTypes<Pick<StoreModules, "roleModule">> &
  AgenceStoreModuleTypes<Pick<StoreModules, "agenceModule">> &
  StateStoreModuleTypes<Pick<StoreModules, "stateModule">> &
  DeviceStoreModuleTypes<Pick<StoreModules, "deviceModule">> &
  CategoryStoreModuleTypes<Pick<StoreModules, "categoryModule">> &
  SurveyStoreModuleTypes<Pick<StoreModules, "surveyModule">> &
  PosteStoreModuleTypes<Pick<StoreModules, "posteModule">> &
  LogStoreModuleTypes<Pick<StoreModules, "logModule">> &
  CategoryStoreModuleTypes<Pick<StoreModules, "historicModule">> &
  CameraResolutionStoreModuleTypes<Pick<StoreModules, "cameraResolutionModule">> &
  MainStateStoreModuleTypes<Pick<StoreModules, "mainStateModule">> &
  CameraImageStoreModuleType<Pick<StoreModules, "cameraImageModule">>;

export const store = new Vuex.Store(auth) as Store;
